import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytesToReadable'
})
export class BytesToReadablePipe implements PipeTransform {

  transform(value: number, decimals: number = 2): string {
    if (value === 0) return '0 Bytes';
    if (!value) return '';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

    const i = Math.floor(Math.log(value) / Math.log(k));
    const size = parseFloat((value / Math.pow(k, i)).toFixed(dm));

    return `${size} ${sizes[i]}`;
  }

}
